import { useQuery } from "@tanstack/react-query";
import { commercialsApi } from "../api/commercials";
import { useTheme } from "@mui/material/styles";
import { formatCurrency } from "../../../shared/utils";

export const useBudgetCategories = (projectId: string | undefined) => {

    const theme = useTheme();

    const colorPalette = [
        theme.palette.primary.main,
        theme.palette.secondary.main,
        theme.palette.info.main,
        theme.palette.success.main,
        theme.palette.warning.main,
        theme.palette.error.main,
    ];

    const getRandomColor = (index: number) => {
        return colorPalette[index % colorPalette.length];
    };

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["project-budget-categories", projectId],
        queryFn: () => commercialsApi.fetchBudgetCategories(projectId),
        enabled: !!projectId
    });

    return {
        data:
            data?.data?.categories.map(
                (v: { name: string; amount: number }, index: number) => ({
                    label: v.name,
                    value: v.amount,
                    color: getRandomColor(index),
                    legendLabel: v.name.concat(" - ", formatCurrency(v.amount)),
                    legendValue: formatCurrency(v.amount),
                })
            ) || [],
        isLoading,
        isError,
        error,
    };
};